@if (navbar.userAccess?.Mailbox=='Full' || navbar.userAccess?.Mailbox=='Readonly') {
@if (showMailLoader) {
<div class="row">
	<div class="col-md-12">
		<div class="text-center">
			<img src="../../../assets/img/loading.gif" style="width: 100px;" />
		</div>
	</div>
</div>
}@else {
<div class="row mb-2">
	<div class="col-12">
		@if (
		viewMail?.email_status!='draft' &&
		!isReply &&
		!mailboxReadonly &&
		navbar.userAccess?.Mailbox=='Full'
		) {
		@if(viewMail?.isActive && replymoduleAccess=='Full'){
		<button (click)="showReply()" class="btn btn-primary btn-xs me-1">
			<fa-icon [icon]="['fas', 'reply']"></fa-icon>
			Reply
		</button>
		}
		@if(
		moduleAccess=='Full' &&
		!apptId &&
		(
		viewMail?.spam ||
		(
		viewMail?.email_status == "unread" ||
		viewMail?.email_status == "read" ||
		viewMail?.email_status == "sent"
		)
		)
		){
		<button type="button" class="btn btn-xs me-1" [ngClass]="viewMail?.spam?'btn-success':'btn-danger'"
			(click)="openMoveMailModal()" [disabled]="loaderMoveMail">
			@if(loaderMoveMail){
			<fa-icon [icon]="['fas', 'spinner']" [animation]="'spin'"></fa-icon>
			}@else {
			@if (!viewMail?.spam) {&nbsp;}
			<fa-icon [icon]="['fas', viewMail?.spam?'check':'exclamation']"></fa-icon>
			@if (!viewMail?.spam) {&nbsp;}
			}
			{{viewMail?.spam?'Mark as not spam':'Mark as spam'}}
		</button>
		}
		@if (moduleAccess=='Full'){
		@if (apptId){
		<button type="button" class="btn btn-xs btn-danger me-1" (click)="unlinkMails()">
			<fa-icon [icon]="['fas', 'unlink']"></fa-icon>
			Unlink
		</button>
		}@else {
		@if (viewMail?.event_id && viewMail?.event_id.length) {
		<!-- <a class="btn btn-xs btn-primary me-1" matTooltip="View Case"
			[routerLink]="['/app/appt-details', encode(viewMail?.event_id), 'empty', 'mails', viewMail?.id]">
			View Cases
		</a> -->
		<button class="btn btn-xs btn-primary me-1" matTooltip="View Cases" (click)="getCases()">
			@if(caseLoader){
			<fa-icon [icon]="['fas', 'spinner']" [animation]="'spin'"></fa-icon>
			}
			View Cases
		</button>
		}
		<!-- @if (
		folder!='spam' &&
		viewMail?.isActive
		) {
		<button type="button" class="btn btn-xs btn-success me-1" (click)="linkMails()">
			<fa-icon [icon]="['fas', 'link']"></fa-icon>
			Link
		</button>
		} -->
		}
		@if (
		folder!='spam' &&
		viewMail?.isActive
		) {
		<button type="button" class="btn btn-xs btn-success me-1" (click)="linkMails()">
			<fa-icon [icon]="['fas', 'link']"></fa-icon>
			Link
		</button>
		}
		}
		}
		@if(isReply){
		<button class="btn btn-xs btn-success me-1" (click)="saveMail('save_reply_draft')">
			<fa-icon [icon]="['fas', 'save']"></fa-icon>
			Save Reply Draft
		</button>
		<button (click)="saveMail('mail_reply_message')" class="btn btn-xs btn-success me-1">
			<fa-icon [icon]="['fas', 'paper-plane']"></fa-icon>
			Send
		</button>
		<button (click)="openTemplateModal()" class="btn btn-xs btn-primary me-1">
			<fa-icon [icon]="['fas', 'list']"></fa-icon>
			Template
		</button>
		}
		@if (
		viewMail?.email_status == 'draft' &&
		!mailboxReadonly &&
		navbar.userAccess?.Mailbox=='Full'
		){
		@if (replymoduleAccess=='Full') {
		<button (click)="saveMail('compose_mail')" class="btn btn-xs btn-success me-1">
			<fa-icon [icon]="['fas', 'paper-plane']"></fa-icon>
			Send
		</button>
		}
		@if (moduleAccess=='Full') {
		<button (click)="saveMail('update_draft')" class="btn btn-xs btn-success me-1">
			<fa-icon [icon]="['fas', 'save']"></fa-icon>
			Update Draft
		</button>
		<button (click)="discardDraft()" class="btn btn-xs btn-danger me-1">
			<fa-icon [icon]="['fas', 'trash-alt']"></fa-icon>
			Discard Draft
		</button>
		}
		}
		<fa-icon [icon]="['fas', 'times']" class="float-end" role="button" (click)="closeMail()" matTooltip="Close">
		</fa-icon>
	</div>
</div>
@if(isReply || viewMail?.email_status == 'draft'){
<div class="row">
	<div class="col-md-12">
		<div class="card">
			<div class="card-body">
				<form [formGroup]="form">
					<app-mail-form formControlName="mail"></app-mail-form>
				</form>
				@if(!mailboxReadonly && navbar.userAccess?.Mailbox=='Full'){
				<app-file-uploader #fileUploaderComponent></app-file-uploader>
				}
				@if(
				viewMail?.email_status == 'draft' &&
				viewMail?.attachmentsArr!=null &&
				viewMail?.attachmentsArr.length
				){
				<div class="card">
					<div class="card-body">
						<h4 class="my-0 fw-bold">
							Draft Files
						</h4>
						<view-attachments [attachmentsArr]="viewMail?.attachmentsArr" [showDelete]="true">
						</view-attachments>
					</div>
				</div>
				}
			</div>
		</div>
	</div>
</div>
}
@if(viewMail){
<!-- <app-mail-display [mail]="viewMail" [showTrail]="true" [showReplyBtn]="true" [apptId]="apptId"
	[hideMain]="viewMail?.email_status=='draft' && !viewMail?.reply_id" (mail_html_fetched)="mail_html_fetched($event)"
	(reply)="showReply()">
</app-mail-display> -->
<app-mail-display [mail]="viewMail" [showTrail]="true" [showReplyBtn]="true" [apptId]="apptId"
	[hideMain]="viewMail?.email_status=='draft'" (mail_html_fetched)="mail_html_fetched($event)" (reply)="showReply()">
</app-mail-display>
}
}
}@else {
<div>
	<h3 class="text-center">You don't have access to this section.</h3>
</div>
}
<div class="modal fade" id="caseListModal" role="dialog">
	<div class="modal-dialog modal-lg">
		<div class="modal-content">
			<div class="modal-header text-center">
				<h4 class="modal-title">
					<strong>Cases</strong>
				</h4>
				<button type="button" class="btn-close" data-bs-dismiss="modal"></button>
			</div>
			<div class="modal-body">
				<div class="row g-1">
					<div class="col-lg-12">
						@if (viewMail?.eventList && viewMail?.eventList.length) {
						<table class="table table-bordered table-striped">
							<thead>
								<tr>
									<th>Case Id</th>
									<th>Start Date</th>
									<th>Crew Name</th>
									<th>Case Category</th>
									<th>Status</th>
								</tr>
							</thead>
							<tbody>
								@for (v of viewMail?.eventList; track $index) {
								<tr>
									<td>
										<a [routerLink]="['/app/appt-details','no',v.enc_id,'empty']"
											matTooltip="Details" data-bs-dismiss="modal">
											{{v.case_id}}
										</a>
									</td>
									<td>{{ v.start_date }}</td>
									<td>{{ v.f_name }} {{ v.l_name }}</td>
									<td>{{ v.case_category }}</td>
									<td>{{ v.case_status }}</td>
								</tr>
								}
							</tbody>
						</table>
						}
					</div>
				</div>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal">
					OK
				</button>
			</div>
		</div>
	</div>
</div>
<div class="modal fade" id="mailTemplateModal" role="dialog">
	<div class="modal-dialog modal-lg">
		<div class="modal-content">
			<div class="modal-header text-center">
				<h4 class="modal-title">
					<strong>Mail Templates</strong>
				</h4>
				<button type="button" class="btn-close" data-bs-dismiss="modal"></button>
			</div>
			<div class="modal-body">
				@if (dtOptions) {
				<mat-accordion [multi]="false">
					<table datatable [dtOptions]="dtOptions" class="table table-bordered">
						<thead>
							<tr class="table_head">
								<th style="width: 90% !important;">Template</th>
								<th style="width: 10% !important;"></th>
							</tr>
						</thead>
						@if (dataList.length) {
						<tbody>
							@for (v of dataList; track $index) {
							<tr>
								<td>
									<mat-expansion-panel [expanded]="false">
										<mat-expansion-panel-header class="bg-secondary" [collapsedHeight]="'35px'"
											[expandedHeight]="'40px'">
											<mat-panel-title>
												<strong class="text-white">
													{{ v.name }}
												</strong>
											</mat-panel-title>
											<mat-panel-description> </mat-panel-description>
										</mat-expansion-panel-header>
										<div class="p-2" [innerHTML]="v.body | safeHtml"></div>
									</mat-expansion-panel>
								</td>
								<td>
									<button class="btn btn-xs btn-success ms-1" matTooltip="Copy to mail"
										(click)="copyTemplate(v)">
										<fa-icon [icon]="['fas', 'copy']"></fa-icon>
									</button>
								</td>
							</tr>
							}
						</tbody>
						} @else {
						<tbody>
							<tr>
								<td colspan="2" class="text-center">No data found!</td>
							</tr>
						</tbody>
						}
					</table>
				</mat-accordion>
				}
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal">
					Cancel
				</button>
			</div>
		</div>
	</div>
</div>